import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { useTitleRampNamesExist } from '../shared/useTitleRampNames';
export var TableFooterBase = function () {
    var exists = useTitleRampNamesExist('FooterCellContent', null, 'FooterHorizontalWrapperCornerContent');
    return exists ? (React.createElement(RampWithNameTransform, { rampName: "FooterContainer" },
        React.createElement(RampWithNameTransform, { rampName: "FooterContent" }))) : null;
};
